import { IBase } from "../base.interface";

export const UNITARY_VARIATION_NAME = 'Unitaire';

export interface IVariation extends IBase {
  name: string;

  position?: number;
}